import { LanguageSchema, type Language } from "./trustAPI";

const TRUST_LAST_USED_LANGUAGE_KEY = "privacy:trust-last-used-language";

export const getStoredTrustLanguage = (): Language | null => {
  try {
    const item = localStorage.getItem(TRUST_LAST_USED_LANGUAGE_KEY);
    if (!item) return null;

    const parsed: unknown = JSON.parse(item);
    const result = LanguageSchema.safeParse(parsed);
    return result.success ? result.data : null;
  } catch {
    return null;
  }
};

export const storeTrustLanguage = (language: Language) => {
  try {
    localStorage.setItem(TRUST_LAST_USED_LANGUAGE_KEY, JSON.stringify(language));
  } catch {
    // ignore storage failures so UI flows aren't broken
  }
};
